import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'callback',
    loadComponent: () =>
      import('./features/auth/callback/callback.component').then(
        (m) => m.CallbackComponent,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: '',
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./layout/main-layout/main-layout.component').then(
            (m) => m.MainLayoutComponent,
          ),
        children: [
          { path: '', redirectTo: 'microsites', pathMatch: 'full' },
          {
            path: 'microsites',
            loadComponent: () =>
              import(
                './features/microsites/pages/microsites-listing/microsites-listing.component'
              ).then((m) => m.MicrositesListingComponent),
          },
        ],
      },
      {
        path: 'microsites/:id/edit',
        loadComponent: () =>
          import(
            './features/microsites/pages/microsite-editor/microsite-editor.component'
          ).then((m) => m.MicrositeEditorComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];